import * as React from 'react';
import { Link } from 'react-router-dom';


// styling
import { Button, Card, CardPanel, CardTitle, Col, Row } from 'react-materialize';
import './dashboard.css';


// components
import NavBar from '../../components/CustomNav/CustomNav.Component';

class DashboardPage extends React.Component {
    public render() {
      const dashboardStyles = {
        dashBody: {
          height: 'auto',
          marginTop: '1%',
          width: 1080,
        },

        wrapper: {
          display: 'flex',
          justifyContent: 'center'
        }

      }
      return (
        <div>
          <NavBar />
          <div style={dashboardStyles.wrapper}>
            <div style={dashboardStyles.dashBody}>
              <h5>Welcome, Username</h5>

              <Card header={<CardTitle waves='light'/>}
                  title="You have no interactions yet, click below to get started">
                  <Link to='/create-interaction-wizard'><Button waves='light'>Get started</Button></Link>
              </Card>

              <br />

              <Card header={<CardTitle waves='light'/>}
                  title="Interaction Templates">

                                  <Row>
                   <Col s={12} m={6}>
                       <CardPanel className="grey lighten-4 black-text">
                         <span>
                           Multiple Choice
                         </span>
                       </CardPanel>
                       <Link to='/recall-interaction-template'>
                       <CardPanel className="grey lighten-4 black-text">
                         <span>
                          Recall
                         </span>
                       </CardPanel>
                       </Link>
                     </Col>
                    <Col s={12} m={6}>

                       <CardPanel className="grey lighten-4 black-text">
                         <span>
                           Drag and Drop
                         </span>
                       </CardPanel>

                       <CardPanel className="grey lighten-4 black-text">
                         <span>
                           Fill in the blank
                         </span>
                       </CardPanel>
                   </Col>
                </Row>

              </Card>

            </div>
          </div>
        </div>
      );
    }
}

export default DashboardPage;



// WEBPACK FOOTER //
// ./src/pages/InteractionsDashboard/dashboardPage.Component.tsx